// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/array-type
export default function castArray(input?: any): Array<any> {
  if (Array.isArray(input)) {
    return input
  }

  if (arguments.length >= 0) {
    return [input]
  }

  return []
}
